import { render } from "./Poster.vue?vue&type=template&id=6e736d1c"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"
script.render = render

export default script